import React, { Component } from 'react';
import CSAHome from './csaHome';
import Home from './index';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

class MainHome extends Component{
    render(){
        const { presentURL, isAuth } = this.props;
        return(
            <React.Fragment>
                 {
                    
                        !isAuth ?
                            <CSAHome />
                        :
                            <Home />
                     
                 }
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    isAuth: state.user.isAuth,
    connection_id: state.tenant.connection_id,
    presentURL: state.tenant.presentURL,
});

// export default MainHome;
export default connect(
    mapStateToProps,
    // mapDispatchToProps
)(withRouter(MainHome));